<div
  *ngIf="!userProcess.hasFullHandling && !userProcess.hasAssistantService"
  class="service-item basic-support"
  [class]="{
    large: mode === PurchaseTags.LARGE,
    small: mode === PurchaseTags.SMALL,
    icon_only: mode === PurchaseTags.ICON_ONLY
  }"
  [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
  [matTooltip]="'COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate"
  matTooltipClass="universalTooltip">
  <mat-icon fontSet="material-symbols-outlined">draft</mat-icon>
  <ng-container *ngIf="mode !== PurchaseTags.ICON_ONLY">
    {{ 'COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate }}
  </ng-container>
</div>
<div
  *ngIf="userProcess.hasFullHandling"
  class="service-item full-handling"
  [class]="{
    large: mode === PurchaseTags.LARGE,
    small: mode === PurchaseTags.SMALL,
    icon_only: mode === PurchaseTags.ICON_ONLY
  }"
  [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
  [matTooltip]="'COMMON.LAYOUT.HAS_FULL_HANDLING' | translate"
  matTooltipClass="universalTooltip">
  <mat-icon fontSet="material-icons-outlined">star</mat-icon>
  <ng-container *ngIf="mode !== PurchaseTags.ICON_ONLY">
    {{ 'COMMON.LAYOUT.HAS_FULL_HANDLING' | translate }}
  </ng-container>
</div>
<div
  *ngIf="!userProcess.hasFullHandling && userProcess.hasAssistantService"
  class="service-item assistant"
  [class]="{
    large: mode === PurchaseTags.LARGE,
    small: mode === PurchaseTags.SMALL,
    icon_only: mode === PurchaseTags.ICON_ONLY
  }"
  [matTooltipDisabled]="mode !== PurchaseTags.ICON_ONLY"
  [matTooltip]="'COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate"
  matTooltipClass="universalTooltip">
  <mat-icon fontSet="material-icons-outlined">person</mat-icon>
  <ng-container *ngIf="mode !== PurchaseTags.ICON_ONLY">
    {{ 'COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate }}
  </ng-container>
</div>
